import { MainLayout } from "~/components/layout/MainLayout";
import { getGlobalAuthChecked } from "~/components/layout/utils/authState";
import RouteRenderer from "~/components/routing/RouteRenderer";
import { useAuthCheck } from "~/hooks/useAuthCheck";
import { getPageTitle } from "~/utils/routingUtils";

interface RoleBasedRouterProps {
  path: string;
}

const RoleBasedRouter: React.FC<RoleBasedRouterProps> = ({ path }) => {
  const { userRole, isLoading } = useAuthCheck(path);

  // If on login page, don't wrap with MainLayout
  if (path === "/login") {
    return null;
  }

  // Get the global auth check status using the getter
  const globalAuthChecked = getGlobalAuthChecked();

  // If still loading and we haven't checked auth yet, show loading
  if (isLoading && !globalAuthChecked) {
    return (
      <div className="flex h-screen items-center justify-center">
        Cargando...
      </div>
    );
  }

  // If we're still loading but we've already checked auth globally, don't show loading
  if (isLoading && globalAuthChecked) {
    return null;
  }

  // If no role yet, don't render anything
  if (!userRole) {
    return null;
  }

  // Render the component
  const component = <RouteRenderer path={path} userRole={userRole} />;
  if (!component) return null;

  return (
    <MainLayout userRole={userRole} pageTitle={getPageTitle(path)}>
      {component}
    </MainLayout>
  );
};

export default RoleBasedRouter;
